<template>
  <b-row>
    <b-col>
      <b-card title="Aportes a seguridad social">
        <ValidationObserver ref="observer">
          <b-form @submit.prevent="save">
            <b-row class="pt-4">
              <b-col lg="4">
                <validation-provider
                  name="ARL"
                  :rules="{ required: true }"
                  v-slot="validationContext"
                >
                <b-form-group id="input-group-company1" label="ARL:" label-for="input-company1" :invalid-feedback="validationContext.errors[0]" >
                  <b-form-select id="input-company1" v-model="form.idArl" :options="arls" required
                  :state="getValidationState(validationContext)"></b-form-select>
                </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="pull-right">
                <b-button variant="primary" type="submit" class="mr-2 mb-3 mt-3">Guardar cambios</b-button>
                <!-- <b-button @click="save()" variant="primary" type="submit" class="mr-2 mb-3 mt-3">Guardar cambios</b-button> -->
                <b-button  v-on:click="$emit('set-config', 0)" class="btn btn-light btn-sm" variant="light">
                  Ir atrás
                </b-button>
              </b-col>
              <!-- v-on:click="$emit('set-config', dataConfig)" -->
            </b-row>
          </b-form>
        </ValidationObserver>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import apiClient2 from '@/services/axios/v2.js'
import { mapState } from 'vuex'
// import { validateDV } from '@/services/utilities'

export default {
  name: 'socialSecuritySettings',
  components: {
  },
  data() {
    return {
      arls: [],
      invalid: false,
      form: {
        idArl: null,
      },
    }
  },
  computed: {
    ...mapState(['user']),
  },
  created () {
    // TODO Una vez implementado el get de school en la v2 de la api
    // se puede hacer un promise.all como dice esta pagina: https://blog.logrocket.com/using-axios-all-make-concurrent-requests/
    apiClient2.get('/arls').then(data => {
      this.arls = data.data.data.map((x) => {
        return {
          value: x.id,
          text: x.name,
        }
      })
      this.arls.unshift({ value: null, text: 'Seleccione una opción' })
    }).catch(error => {
      console.log(error)
      this.$notification.error({
        message: 'Ooops ocurrió un error',
        description: error.response.data.msg,
      })
    })
    apiClient2.get('/company/1').then(data => {
      this.form.idArl = data.data.data.idArl
    }).catch(error => {
      console.log(error)
      this.$notification.error({
        message: 'Ooops ocurrió un error',
        description: error.response.data.msg,
      })
    })
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    async save() {
      const isValid = await this.$refs.observer.validate()
      console.log(isValid)
      if (isValid) {
        apiClient2.patch('/company/1', this.form).then(response => {
          this.$notification.success({
            message: 'Cambio guardado',
            description: 'La institución ha sido actualizada exitosamente.',
          })
        })
      }
    },
  },
  watch: {
  },
}
</script>
